<template>
    <q-dialog v-model="showModal" persistent>
        <q-card style="width: 500px; max-width: 80vw;">
            <q-card-section>
                <slot name="header">
                    <div class="text-h6"><q-icon name="far fa-object-group" size="sm"/> Withdraw merged records</div>
                </slot>
            </q-card-section>

            <q-separator/>

            <q-card-section>
                <form>
                    <div class="row q-col-gutter-md">
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.amount"
                                :label="$t('transfers.withdrawal_table_titles.amount')"
                                color="primary"
                            >
                                <template v-slot:append>
                                    <small>{{payload.from_currency}}</small>
                                </template>
                            </q-input>
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.pre_assigned_code"
                                :label="$t('transfers.withdrawal_table_titles.pre_assigned_code')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.reference"
                                :label="$t('transfers.withdrawal_table_titles.reference')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.sent_payment_to_country"
                                :label="$t('transfers.withdrawal_table_titles.sent_payment_to_country')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.bank_name"
                                :label="$t('transfers.withdrawal_table_titles.bank_name')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.bank_swift_bic"
                                :label="$t('transfers.withdrawal_table_titles.swift_bic')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.to_account_number"
                                :label="$t('transfers.withdrawal_table_titles.to_account_number')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.bank_account_name"
                                :label="$t('transfers.withdrawal_table_titles.bank_account_name')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.bank_owner_address_1"
                                :label="$t('transfers.withdrawal_table_titles.bank_owner_address_1')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.bank_owner_address_2"
                                :label="$t('transfers.withdrawal_table_titles.bank_owner_address_2')"
                                color="primary"
                            />
                        </div>
                        <div class="col col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <q-input
                                v-model="payload.bank_owner_address_country"
                                :label="$t('transfers.withdrawal_table_titles.bank_owner_address_country')"
                                color="primary"
                            />
                        </div>
                    </div>
                </form>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat label="cancel" color="primary" v-close-popup/>
                <q-btn label="Withdraw" color="primary" @click="submit"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
export default {
    name: "MergedWithdrawalsDialog",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        withdrawalObj: {
            type: Object,
            required: true
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data: function () {
        return {
            payload: undefined
        }
    },
    methods: {
        submit() {
            this.$emit('submit', this.payload)
            this.showModal = false
        }
    },
    created () {
        this.payload = this.withdrawalObj
    },
    mounted () {},
    components: {}
}
</script>

<style scoped>

</style>

